// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dedfcf78","453":"810a5aa5","644":"dbdb48e8","667":"ae520d0e"}[chunkId] + ".chunk.js";
};